"use strict";

exports.__esModule = true;
exports.RealtimeConnectionController = void 0;
var _react = require("react");
var _libRealtime = require("@vimana/lib-realtime");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Makes a realtime connection available via a render prop.
 */
var RealtimeConnectionController = exports.RealtimeConnectionController = /*#__PURE__*/function (_Component) {
  function RealtimeConnectionController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      cache: undefined,
      // eslint-disable-next-line react/no-unused-state
      connection: undefined,
      // eslint-disable-next-line react/no-unused-state
      isConnected: false,
      // eslint-disable-next-line react/no-unused-state
      error: undefined
    };
    return _this;
  }
  _inheritsLoose(RealtimeConnectionController, _Component);
  var _proto = RealtimeConnectionController.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var manager = this.createManagerFromProps(this.props);
    this.manager = manager;
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.manager === undefined) {
      this.manager = this.createManagerFromProps(this.props);
    } else {
      this.manager.getWebSocket = this.props.getWebSocket;
      this.manager.getCredentials = this.props.getCredentials;
      this.manager.onCommand = this.props.onCommand;
      if (typeof this.props.minReconnectDelay === "number") {
        this.manager.minReconnectDelay = this.props.minReconnectDelay;
      }
      if (typeof this.props.maxReconnectDelay === "number") {
        this.manager.maxReconnectDelay = this.props.maxReconnectDelay;
      }
      if (typeof this.props.reconnectBackoffFactor === "number") {
        this.manager.reconnectBackoffFactor = this.props.reconnectBackoffFactor;
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var manager = this.manager;
    if (manager) {
      manager.dispose();
      this.manager = undefined;
    }
  };
  _proto.createManagerFromProps = function createManagerFromProps(props) {
    var _this2 = this;
    var manager = new _libRealtime.RealtimeConnectionManager({
      getWebSocket: props.getWebSocket,
      getCredentials: props.getCredentials,
      minReconnectDelay: props.minReconnectDelay,
      maxReconnectDelay: props.maxReconnectDelay,
      reconnectBackoffFactor: props.reconnectBackoffFactor,
      onOpen: function onOpen(connection) {
        var cache = new _libRealtime.RealtimeSubscriptionCache({
          connection: connection
        });
        _this2.setState({
          // eslint-disable-next-line react/no-unused-state
          connection: connection,
          cache: cache,
          // eslint-disable-next-line react/no-unused-state
          isConnected: true,
          // eslint-disable-next-line react/no-unused-state
          error: undefined
        });
      },
      onCommand: props.onCommand,
      onClose: function onClose() {
        var state = _this2.state;
        if (state.cache) {
          state.cache.dispose();
        }
        _this2.setState({
          // eslint-disable-next-line react/no-unused-state
          cache: undefined,
          // eslint-disable-next-line react/no-unused-state
          connection: undefined,
          // eslint-disable-next-line react/no-unused-state
          isConnected: false
        });
      },
      onError: function onError(error) {
        var state = _this2.state;
        if (state.cache) {
          state.cache.dispose();
        }
        _this2.setState({
          // eslint-disable-next-line react/no-unused-state
          cache: undefined,
          // eslint-disable-next-line react/no-unused-state
          connection: undefined,
          // eslint-disable-next-line react/no-unused-state
          isConnected: false,
          // eslint-disable-next-line react/no-unused-state
          error: error
        });
      }
    });
    manager.getConnection();
    return manager;
  };
  _proto.render = function render() {
    var children = this.props.children;
    return children(this.state);
  };
  return RealtimeConnectionController;
}(_react.Component);
RealtimeConnectionController.defaultProps = {
  onCommand: function onCommand(commandName, payload) {
    if (commandName === "keepAlive") {
      return;
    }
    // eslint-disable-next-line no-console
    console.log("Received unknown command from the server:", commandName, payload);
  }
};